import {IS_MODAL_LOADED} from '../actions/set-is-loaded';

export default function isModalLoaded(state = false, action) {
  const {type, payload} = action;
  switch (type) {
    case IS_MODAL_LOADED:
      return payload;
    default:
      return state;
  }
}
